import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const [buttonText, setButtonText] = useState("Book Dog Training");
  const [serviceLink, setServiceLink] = useState("/training");

  const services = [
    {
      icon: "//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__grooming-icon.svg",
      title: "Pet Grooming",
      description: "Book In-Home Cat and Dog Grooming Service",
      link: "/grooming",
    },
    {
      icon: "//dm6g3jbka53hp.cloudfront.net/static-images/menu__item-pet__boarding.png",
      title: "Pet Boarding",
      description: "Book Cat and Dog Boarding Service",
      link: "/boarding",
    },
    {
      icon: "//dm6g3jbka53hp.cloudfront.net/static-images/home-page_book-services-second-section-dog-walking-icon.svg",
      title: "Dog Walking",
      description: "Book Personalised Dog Walkers Near You",
      link: "/walking",
    },
    {
      icon: "//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__vet-icon.svg",
      title: "Vet on Call",
      description: "Expert Veterinary Service At Your Home and Online",
      link: "/vet",
    },
    {
      icon: "//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__adopt-icon.svg",
      title: "Adopt a Pet",
      description: "Adopt, Don't Shop: Save a Life Today",
      link: "/adopt",
    },
    {
      icon: "//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__training-icon.svg",
      title: "Dog Training",
      description: "Book Dog Training Service At Home",
      link: "/training",
    },
  ];

  const citySelector = {
    icon: "//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__pin-icon.svg",
    label: "Your City",
    placeholder: "Select city here...",
  };

  const dateSelector = {
    icon: "//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__calender-icon.svg",
    label: "Service date",
    placeholder: "Select service date here...",
  };

  const handleButtonClick = (title, link) => {
    setButtonText(title);
    setServiceLink(link);
  };

  return (
    <div>
      <div className='w-full h-[400px] sm:h-[500px] lg:h-[600px] overflow-hidden bg-white' style={{ backgroundImage: 'url(./PetCares.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>

      <div className='border-4 border-slate-300 gap-14 w-[90%] sm:w-[80%] lg:w-[80%] mx-auto relative mt-[-150px] bg-white p-6'>
        <div className='text-center mt-10'>
          <p className='text-3xl sm:text-4xl font-bold'>Your Trusted Pet Care Partner</p>
          <p className='text-lg sm:text-xl'>Book Pet Care Services Today</p>
        </div>

        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14'>
          {services.map((service, index) => (
            <div key={index} className='mx-auto'>
              <button
                className='border-2 border-gray-400 hover:border-orange-500 -mx-3 sm:w-[320px] w-[290px] h-[120px]  rounded-lg text-black active:bg-orange-500 active:text-white p-6'
                onClick={() => handleButtonClick(service.title, service.link)}
              >
                <img src={service.icon} alt="" className='h-16 w-16 ml-3' />
                <p className='ml-14 mt-[-60px] font-bold text-xl'>{service.title}</p>
                <p className='mt-1 ml-20 text-sm'>{service.description}</p>
              </button>
            </div>
          ))}
        </div>

        <div className='flex flex-col sm:flex-row gap-6 mt-9'>
          <div className="city-selector w-full sm:w-[380px]">
            <label className='font-semibold'>{citySelector.label}</label>
            <div className='flex items-center border border-slate-300 rounded-lg mt-2'>
              <input type="text" placeholder={citySelector.placeholder} className='w-full sm:w-[380px] h-12 rounded-md outline-none' />
              <img src={citySelector.icon} alt="" className="ml-2 h-6 w-6" />
            </div>
          </div>
          <div className="date-selector w-full sm:w-[380px]">
            <label className='font-semibold'>{dateSelector.label}</label>
            <div className='flex items-center border border-slate-300 rounded-lg mt-2'>
              <input type="date" placeholder={dateSelector.placeholder} className='w-full sm:w-[380px] h-12 outline-none' />
              <img src={dateSelector.icon} alt="" className="ml-2 h-6 w-6" />
            </div>
          </div>
          <Link to={serviceLink} className='w-full sm:w-[300px] mt-5'>
            <button className='bg-orange-600 w-full sm:w-[300px] h-14 rounded-2xl text-2xl text-white font-extrabold'>
              {buttonText}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Hero;
